import { z } from "zod";

import { systemFields, zDate, zMedia } from "@/lib/zod/show-fragments";

/** Read-only view schema for the Leagues show page — full LeagueDbDto. */
export const leagueViewSchema = z
  .object({
    id: z.string(),
    name: z.string().nullish(),
    slug: z.string().nullish(),
    sport: z.string().nullish(),
    country: z.string().nullish(),
    gender: z.string().nullish(),
    ageGroup: z.string().nullish(),
    tier: z.number().nullish(),
    enabled: z.boolean().nullish(),
    currentSeason: z.string().nullish(),
    seasonStart: zDate,
    seasonEnd: zDate,
    teamsCount: z.number().nullish(),
    status: z.string().nullish(),
    hide: z.boolean().nullish(),
    media: zMedia.nullish(),
    metadata: z
      .object({
        source: z.string().nullish(),
        sourceId: z.string().nullish(),
      })
      .passthrough()
      .nullish(),
    ...systemFields,
  })
  .passthrough();

export type LeagueViewType = z.infer<typeof leagueViewSchema>;
